"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Calendar = function Calendar(_ref) {
  var width = _ref.width,
    color = _ref.color;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("g", {
    fill: color,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 3.75h16c.966 0 1.75.784 1.75 1.75v12A1.75 1.75 0 0 1 18 19.25H2A1.75 1.75 0 0 1 .25 17.5v-12c0-.966.784-1.75 1.75-1.75zm0 1.5a.25.25 0 0 0-.25.25v12c0 .138.112.25.25.25h16a.25.25 0 0 0 .25-.25v-12a.25.25 0 0 0-.25-.25H2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.75h17v-1.5h-17zM14.25 1v3a.75.75 0 1 0 1.5 0V1a.75.75 0 1 0-1.5 0zM4.25 1v3a.75.75 0 0 0 1.5 0V1a.75.75 0 0 0-1.5 0z"
  })));
};
var defaultProps = {
  width: 20,
  color: _constants.colors.darkBlue
};
Calendar.defaultProps = defaultProps;
var _default = exports["default"] = Calendar;